@for (item of items(); track item.label) {
  <button
    type="button"
    role="menuitem"
    class="context-menu-item"
    (click)="onItemClick($event, item)"
  >
    @if (item.icon) {
      <i class="context-menu-item__icon fas fa-{{ item.icon }}" aria-hidden="true"></i>
    }
    <span class="context-menu-item__label">{{ item.label }}</span>
  </button>
}
